import React from 'react';
import { Link } from 'react-router-dom';

export type CdTab = 'overview' | 'deployments' | 'artifacts';

export const CdAppTabs: React.FC<{ appId: string; active: CdTab }> = ({ appId, active }) => {
  const tabs: Array<{ key: CdTab; label: string; path: string }> = [
    { key: 'overview', label: 'Overview', path: `/cd/apps/${appId}` },
    { key: 'deployments', label: 'Deployments', path: `/cd/apps/${appId}/deployments` },
    { key: 'artifacts', label: 'Artifacts', path: `/cd/apps/${appId}/artifacts` },
  ];
  return (
    <nav className="change-tabs cd-app-tabs" aria-label="CD App sections">
      {tabs.map(tab => (
        <Link
          key={tab.key}
          className={active === tab.key ? 'is-active' : undefined}
          aria-current={active === tab.key ? 'page' : undefined}
          to={tab.path}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
};
